import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import {
  getAllPointGain,
} from '../../modules/reward'
import RemovePointTransaction from './components/RemovePointTransaction'
import RedeemPointTransaction from './components/RedeemPointTransaction'
import {
  Card,
  Table,
  Button,
  Input,
  Icon,
  Tag,
  Avatar,
  Select,
  Col,
  Row,
  Form,
  Tabs,
} from 'antd'
import { POINTACTION, POINT_CHANNEL_LABEL } from '../../utils/constants'
import { useDeepEffect } from '../../utils/hooks'
import _ , { isEmpty }from 'lodash'
import Highlighter from 'react-highlight-words'

const initialOptions = {
  page: 0,
  size: 20,
  user: '',
  action: '',
  desc: true
}

const PointTransaction = ({ form }) => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const { validateFields, getFieldDecorator } = form
  const [searchText, setSearchText] = useState('')
  const [filterOption, setFilterOption] = useState(initialOptions)

  const { allPointGain ,isLoading } = useSelector(
    (state) => ({
      allPointGain: state.reward.pointGainList,
      isLoading: state.reward.isLoading
    }),
    []
  )

  const GetDate = (d) => {
    let date = ''
    if (d !== null) {
      date = moment(d).format('DD/MM/YYYY')
    }
    return date
  }

  async function fetch() {
    await dispatch(getAllPointGain(filterOption))
  }

  useDeepEffect(() => {
    fetch()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const refetchData = async () => { }

  const columns = [
    {
      title: 'วันที่',
      dataIndex: 'createDate',
      key: 'createDate',
      render: (createDate) => {
        const datesubmit = GetDate(createDate)
        return (
          <span>
            {datesubmit}
          </span>
        )
      }
    },
    {
      title: 'ชื่อผู้ใช้',
      dataIndex: 'user',
      key: 'user',
      ...getColumnSearchProps('user'),
      render: (name, row) => (
        <div>
          <Row type="flex" gutter={8} align="middle">
            <Col>
              <Avatar src={row.userImage} size={48} />
            </Col>
            <Col>
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={name.toString()}
              />
            </Col>
          </Row>
        </div>
      )
    },
    {
      title: 'การกระทำ',
      dataIndex: 'action',
      key: 'action',
      ...getColumnSearchProps('action')
    },
    {
      title: 'กระเป๋า',
      dataIndex: 'scopeName',
      key: 'scopeName',
      render: (name) => name || '-'
    },
    {
      title: 'ช่องทาง',
      dataIndex: 'channel',
      key: 'channel',
      // ใช้ตารางป้ายเต็ม ไม่ใช่รายการที่ให้เลือก — ข้อมูลจริงมีช่องทางที่แอดมินเลือกไม่ได้ด้วย
      render: (channel) => POINT_CHANNEL_LABEL[channel] || channel || '-'
    },
    {
      title: 'คะแนน',
      dataIndex: 'point',
      key: 'point',
      render: (point) => {
        return (
          <span>
            <Tag color='green' key={point}>
              + {point}
            </Tag>
          </span>
        )
      }
    }
  ]
  async function onShowSizeChange(current, pageSize) {
    filterOption.size = pageSize
    setFilterOption(filterOption)
    await dispatch(getAllPointGain(filterOption))
    refetchData()
  }

  async function onChange(page) {
    filterOption.page = page - 1
    setFilterOption(filterOption)
    await dispatch(getAllPointGain(filterOption))
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        if (values.action === 'all') {
          filterOption.action = ''
        } else {
          filterOption.action = values.action
        }
        if (values.user) {
          filterOption.user = values.user
        } else {
          filterOption.user = ''
        }
        filterOption.page = 0
        await dispatch(getAllPointGain(filterOption))
      }
    })
  }

  async function onClear() {
    filterOption.page = initialOptions.page
    filterOption.size = initialOptions.size
    filterOption.user = ''
    filterOption.action = ''
    filterOption.desc = true
    form.resetFields()
    await dispatch(getAllPointGain(filterOption))
  }

  return (
    <Card
      title="Point Transaction"
      extra={
        <div>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }>
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab="Gain Point Transaction" key="1">
          <Form onSubmit={onSubmit} layout="inline">
            <Row type="flex" justify="end" align="middle">
              <Col>
                <Row type="flex" justify="end" gutter={8} align="middle">
                  <Col>
                    <Form.Item style={{ margin: 0 }} label="ค้นหาชื่อผู้ใช้">
                      {getFieldDecorator(`user`)(
                        <Input
                          style={{ width: 200 }}
                          placeholder="ชื่อผู้ใช้"
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item style={{ margin: 0 }} label="การกระทำ">
                      {getFieldDecorator(`action`, {
                        initialValue: 'all'
                      })(
                        <Select style={{ width: 150 }}>
                          <Select.Option value="all">ทั้งหมด</Select.Option>
                          {POINTACTION.map((type) => {
                            return (
                              <Select.Option key={type} value={type}>
                                {type}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col>
                    <Button type="primary" htmlType="submit">
                      ค้นหา
                    </Button>
                  </Col>
                  <Col>
                    <Button type="danger" onClick={() => onClear()}>
                      เคลียร์
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
          {!isEmpty(allPointGain) && (
            <Table
              bordered
              loading={isLoading}
              scroll={{ x: 1000 }}
              rowKey={(record) => record.id}
              dataSource={allPointGain.content}
              columns={columns}
              pagination={{
                current: (allPointGain.pageable && allPointGain.pageable.pageNumber + 1) || 1,
                pageSize: allPointGain.size,
                pageSizeOptions: ['10', '20', '50', '100'],
                showSizeChanger: true,
                onShowSizeChange: onShowSizeChange,
                onChange: onChange,
                total: allPointGain.totalElements || 0
              }}
            />
          )}
        </Tabs.TabPane>
        <Tabs.TabPane tab="Remove Point Transaction" key="2">
          <RemovePointTransaction />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Redeem Point Transaction" key="3">
          <RedeemPointTransaction />
        </Tabs.TabPane>
      </Tabs>
    </Card>
  )
}

const WrappedPointTransaction = Form.create({ name: 'PointTransaction' })(PointTransaction)
export default WrappedPointTransaction